import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import branch from 'recompose/branch';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import renderNothing from 'recompose/renderNothing';
import { withRouter } from 'react-router';
import any from 'ramda/es/any';
import prop from 'ramda/es/prop';

import * as balanceActions from 'app/actions/cafeteria/balance';
import { getIsParent } from 'app/selectors/user';
import selectStudents from './selectStudents';


const StudentsSelectorContainer = compose(
  withRouter,


  connect(
    (state, props) => ({
      students: getIsParent(state) ? selectStudents(state, props) : [],
      isParent: getIsParent(state),
      balance: state.cafeteria.balance,
    }),
    dispatch => ({
      actions: bindActionCreators(balanceActions, dispatch),
    })
  ),


  // mapProps((props) => {
  //   console.log('StudentsSelectorContainer: ', props);
  //   return props;
  // }),


  lifecycle({
    componentDidMount() {
      const { balance, students, actions } = this.props;
      if (balance.result !== 'success' && students.length && any(prop('showBalance'), students)) {
        actions.fetchBalance();
      }
    },
  }),


  branch(
    props => !props.students.length,
    renderNothing
  )
);

export default StudentsSelectorContainer;
